import { useContext } from 'react';
import * as Table from '@/components/Table';
import { useProjectOrLatestChild } from '@/containers/GroupProject/hooks/useProjectOrLatestChild';
import { AdditionalFilters } from './AdditionalFilters';
import { ProjectClipsDataContext } from './context';
import { HighlightsContainer } from './Highlights.Container';
import { HighlightsTable } from './Highlights.Table';
import { KeywordSearch } from './KeywordSearch';
import styles from './style/Project.Clips.module.css';

type Props = unknown;

export const ProjectHighlights = (props: Props) => {

  return (
    <HighlightsContainer>
      <ProjectClips />
    </HighlightsContainer>
  );
};

ProjectHighlights.displayName = 'Project.Highlights';

const ProjectClips = () => {
  const project = useProjectOrLatestChild();
  const suspended = useContext(ProjectClipsDataContext);

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <Table.Layout.Box>
          <Table.Layout.Header title="Highlights">
            <div className={styles.search}>
              <KeywordSearch />
              <AdditionalFilters />
            </div>
            {/* <Actions projectId={project.id} /> */}
          </Table.Layout.Header>

          <HighlightsTable
            data={suspended.data}
            empty={suspended.empty}
            loading={suspended.loading} />
        </Table.Layout.Box>
      </div>
    </div>
  );
};